<router-outlet></router-outlet>
<oab-confirm-host></oab-confirm-host>
<oab-progress-bar></oab-progress-bar>
